import src from "IMAGE";
export default { src, width: 1390, height: 40, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABYVGyMVFBoiEREZKxISGzMEBAYLAAAAACwsLTLJydDqNcIFwzkGUzgAAAAASUVORK5CYII="};
